import React from "react";
import { useSelector } from "react-redux";
import {
  selectHelenaEnabled,
  selectHelenaPatientActive,
  selectHelenaPatientUnsubscribed,
  selectHelenaState,
} from "store/reducers/helena.reducer";
import { I18nextProvider, useTranslation } from "react-i18next";
import HelenaPatientRegistrationCard from "main/HelenaRegistration/HelenaPatientRegistrationCard";
import { HelenaStatusEnum } from "model/helena.model";
import { i18nUserContext } from "config/translations/I18n";
import { Alert } from "@cc/react-components";
import { selectPatientSync } from "store/reducers/patient.reducer";
import { SyncServiceType } from "model/patient-sync.model";
import { GlobalState } from "store/configure-store";
import Page from "ui/Page";
export interface Props extends React.HTMLAttributes<HTMLElement> {}

const HelenaPatientActivation = ({ children }: Props) => {
  const [t] = useTranslation();
  const patientSyncHelenaExists = useSelector((state: GlobalState) =>
    selectPatientSync(state, SyncServiceType.HELENA_VISIT_INVITATION)
  );
  const helenaEnabled = useSelector((state: GlobalState) =>
    selectHelenaEnabled(state.helena)
  );
  const invitePatientToHelena = useSelector(
    (state: GlobalState) =>
      !selectHelenaPatientActive(state.helena) &&
      !selectHelenaPatientUnsubscribed(state.helena)
  );
  const { status: helenaStatus } = useSelector(selectHelenaState);

  const renderStatusUp = () => {
    if (helenaEnabled && !patientSyncHelenaExists && invitePatientToHelena) {
      return (
        <HelenaPatientRegistrationCard
          messageKey={"helena.patient.notRegistered.info"}
        />
      );
    } else {
      return <>{children}</>;
    }
  };

  return (
    <Page.Scrollable>
      <Page.Body>
        <I18nextProvider i18n={i18nUserContext}>
          {helenaStatus === HelenaStatusEnum.DOWN && (
            <Alert variant="danger">{t("helena.down")}</Alert>
          )}
          {helenaStatus === HelenaStatusEnum.UP && renderStatusUp()}
        </I18nextProvider>
      </Page.Body>
    </Page.Scrollable>
  );
};

export default HelenaPatientActivation;
